import React from 'react';
import { OrgQueryKeys } from '../../../../../api/config';
import { useOrganizationQuery } from '../../../../../api/queries/use-organization-query';
import { Load, Medication } from '../../../../../types';
import { orderToCargoQuantities } from '../../../../../utils/data-mapping-utils';
import { AgisticsTooltip } from '../../../../shared/agistics-tooltip';
import { useWeights } from '../../../../shared/hooks/use-weights';
import { getMedicationsTagStyle } from '../../../utils/drafts-loads-utils';

interface LoadCargoProps {
    load: Load;
}

export const LoadCargo: React.FC<LoadCargoProps> = (props) => {
    const { load } = props;
    const { data: medications = [] } = useOrganizationQuery<Medication[]>(OrgQueryKeys.medications);
    const { convertFromGramsDisplay } = useWeights();
    // shapeOf [label, amount, [medicationIds]]
    const cargoQuantities = orderToCargoQuantities(load, convertFromGramsDisplay);
    const distinctMedIds = cargoQuantities.flatMap(([_, __, groupMedIds]) => groupMedIds).distinctBy(id => id) as number[];
    const cargoMedsStyle = getMedicationsTagStyle(distinctMedIds, medications);
    
    return (
        <div style={cargoMedsStyle}>
            {cargoQuantities.map(([cargo, quantity, medicationIds]) => {
                const uniqueMedIds = [...new Set(medicationIds)] as number[];
                return (
                    <AgisticsTooltip
                        key={`${quantity}${cargo}`}
                        tooltip={
                            <>
                                {cargo}
                                {uniqueMedIds.length > 0 && (
                                    <>
                                        <hr />
                                        <>
                                            {uniqueMedIds.map(medId => {
                                                const medication = medications.find(med => med.id === medId);
                                                return (
                                                    <div key={medId}>
                                                        {medication ? medication.name : `Unknown Medication (${medId})`}
                                                    </div>
                                                );
                                            })}
                                        </>
                                    </>
                                )}
                            </>
                        }
                    >
                        {quantity ? `${quantity} - ${cargo}` : `${cargo}`}
                    </AgisticsTooltip>
                );
            })}
            {/* <SalmonellaMeter severity={load.metadata?.cargo?.salmonellaResult} /> */}
        </div>
    );
};
